import { OptionDto } from "@/dtos";
import { RouteVehicleType } from "@/helpers/types";

const vehicleTypes = [
    { value: RouteVehicleType.BUS, label: 'Autobus' },
    { value: RouteVehicleType.SMALL_BUS, label: 'Buseta' }
] as OptionDto[];

export const getRouteVehicleTypeOptions = (): OptionDto[] => {
    return vehicleTypes;
}

export const getRouteVehicleTypeOption = (value?: number): OptionDto => {
    return vehicleTypes.find((x) => x.value == value) ?? vehicleTypes[0];
}

export const getRouteVehicleTypeLabel = (value: number): string => {
    return vehicleTypes.find((x) => x.value == value)?.label ?? vehicleTypes[0].label;
}

